import { useTranslation } from 'next-i18next'
import React from 'react'

import { IOS_DOWNLOAD_URL, PLAY_STORE_URL } from '../../constants/appLinks'
import s from './landing.module.css'

interface Props {
  className?: string
}

/**
 * Botões App Store / Google Play (pill ink do design). O botão iOS aponta para
 * o destino oficial de download (`IOS_DOWNLOAD_URL` — TestFlight enquanto não
 * houver listagem na App Store; ver `constants/appLinks.ts`).
 */
export function StoreButtons({ className }: Props) {
  const { t } = useTranslation('landing')
  const appStoreHref = IOS_DOWNLOAD_URL
  const external = (href: string) =>
    href.startsWith('http')
      ? { target: '_blank', rel: 'noopener noreferrer' }
      : {}

  return (
    <>
      <a
        className={`${s.btn} ${className || ''}`}
        href={appStoreHref}
        {...external(appStoreHref)}
      >
        {t('stores.appStore')}
      </a>
      <a
        className={`${s.btn} ${className || ''}`}
        href={PLAY_STORE_URL}
        {...external(PLAY_STORE_URL)}
      >
        {t('stores.googlePlay')}
      </a>
    </>
  )
}
